import { Middleware } from 'redux';
import handleStorageBrowser from '../helpers/handleStorageBrowser';
import { EP } from '../configs/constant';

const shopMiddleware: Middleware = store => next => action => {
    const result = next(action);

    // Lưu trạng thái giỏ hàng vào localStorage
    handleStorageBrowser.setItemLocalStorage(EP.SHOP, store.getState().shop.shopInfo);

    return result;
};

export default shopMiddleware;